<template>
  <section>
    <b-modal
      :active.sync="isContactFormActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Contact Us</p>
        </header>
        <section class="modal-card-body">
          <b-field
            label="Email"
            :type="valid.email.type"
            :message="valid.email.result"
          >
            <b-input
              type="email"
              :value="form.email"
              placeholder="Your email"
              required
            ></b-input>
          </b-field>

          <b-field
            label="Password"
            :type="valid.pass.type"
            :message="valid.pass.result"
          >
            <b-input
              type="password"
              :value="form.pass"
              password-reveal
              placeholder="Your password"
              required
            ></b-input>
          </b-field>

          <b-checkbox>Remember me</b-checkbox>

         <b-message type="is-danger" v-if="form.error">
            {{ form.result }}
          </b-message>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="close()">Close</button>
          <button class="button is-primary" @click="onSubmit">Login</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      form: {
        email: "",
        pass: "",
        visible: true,
        disable: false,
        result: "",
        error: false
      },
      valid: {
        email: {
          type: "",
          result: ""
        },
        pass: {
          type: "",
          result: ""
        }
      }
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$store.commit("DO_LOGIN", true);
      //this.$store.commit("SHOW_MODAL", false);

      if (this.emailCheck("email") & this.formCheck("pass")) {
        this.form.visible = false;
      } else {
        this.form.error = true;
        this.form.result = "Ooops! Something went wrong. Please try again.";
      }
      // if(this.humanCheck('human') & this.emailCheck('email') & this.formCheck('name') & this.formCheck('text')){
      // this.form.disable = true;
      // this.form.visible = false;
      // this.form.result = "Sending message.."

      // this.axios.post(this.$mySite.api+"sendmail.php?must=send&extapi="+this.$mySite.extapi,{
      // e_name: this.form.name,
      // e_email: this.form.email,
      // e_page: window.location.href,
      // })
      // .then(response => {
      // this.form.visible = false;
      // this.form.result = "Your message was sent successfully!";
      // console.log(response);
      // })
      // .catch(error => {
      // this.form.disable = false;
      // this.form.visible = true;
      // this.form.result = "Oops! There was an error! Please try again later!";
      // console.log(error);
      // });//end post
      // console.log("works");
      // //this.formvalidation.human=true;
      // }
    },
    emailCheck(e) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
      if (this.form[e] === "" || !re.test(this.form[e])) {
        this.valid[e].type = "is-danger";
        this.valid[e].result = "Please enter a valid email address";
        return false;
      } else {
        this.valid.email.type = "is-success";
        return true;
      }
    },
    formCheck(e) {
      if (this.form[e] === "") {
        this.valid[e].type = "is-danger";
        this.valid[e].result = "Please fill out all required fields";
        return false;
      } else {
        this.valid[e].type = "is-success";
        return true;
      }
    },
    humanCheck(e) {
      if (this.form[e]) {
        this.formvalidation[e] = true;
        return true;
      } else {
        this.formvalidation[e] = false;
        return false;
      }
    },
    close() {
      //this.isComponentModalActive = false;
      this.$store.commit("SHOW_MODAL", { modal: "contactShow", state: false });
    }
  },
  computed: {
    isContactFormActive: {
      get: function() {
        return this.$store.state.contactShow;
      },
      // setter
      set: function() {
        this.$store.commit("SHOW_MODAL", {
          modal: "contactShow",
          state: false
        });
        return false;
      }
    }
  }
};
</script>
<style scoped>
.modal-card-foot {
  justify-content: space-between; /* flex-end; */
}
</style>
